import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponentBase } from '@wephone-core-ui';
import { IFlexDialogConfig } from '@wephone-utils';
import { PeriodPerformance } from '@wephone/services/user.service';
import { _tk } from 'jsphonelib/translation';

@Component({
  selector: 'app-today-stats-modal',
  templateUrl: './today-stats-modal.component.html'
})
export class TodayStatsModalComponent extends DialogComponentBase {
  static modalConfig: IFlexDialogConfig = {
    size: 'l',
    width: '500px',
    minHeight: '90%'
  };

  SCROLLABLE_CONTENT = true;

  dialogTitle = _tk('notification.today');

  constructor(dialogRef: MatDialogRef<TodayStatsModalComponent>) {
    super(dialogRef);
  }

  periodChanged(period: PeriodPerformance): void {
    this.dialogTitle = _tk('agent_panel.content.period_performance_' + period);
  }
}
